import React from 'react'
import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'
import LoftDetails from '../Loft/LoftDetails'


const Loftpage = () => {
    return (
        <div>
        <Navbar/>
        <LoftDetails/>


        <Footer/>

        </div>
    )
}

export default Loftpage